<!-- <div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Bine ați venit!</h2>
            <h4>
                Registratură InDoc - {{appName}}
            </h4>
        </div>
    </div>
</div> -->

<div class="requests-page">
    <div class="content-box ">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title my-1">Documente înregistrate (Intrare/Ieșire/Intern)</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1 my-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.operations.add-iesire')"
                                style="background-color:#f39c12; border-color: #e08e0b; color: #fff"
                                (click)="openAddDialogIesire()" class="button-add-doc pull-right ms-1 my-1">
                                <i class="fa-solid fa-plus add-icon"></i>
                                <span> Adaugă Doc Ieșire</span>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.operations.add-intern')"
                                style="background-color:#00c0ef; border-color: #00acd6; color: #fff"
                                (click)="openAddDialogIntern()" class="button-add-doc pull-right ms-1 my-1">
                                <i class="fa-solid fa-plus add-icon"></i>
                                <span> Adaugă Doc Intern</span>
                            </button>
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.operations.add-intrare-new')"
                                style="background-color:#00a65a; border-color: #008d4c; color: #fff"
                                (click)="openAddDialogIntrare()" class="button-add-doc pull-right ms-1 my-1">
                                <i class="fa-solid fa-plus add-icon"></i>
                                <span> Adaugă Doc Intrare</span>
                            </button>
                            <!-- <button style="background-color:#3c8dbc ; border-color: #3c8dbc; color: #fff;"
                                (click)="openDocument()" class="button-add-doc pull-right ms-1 my-1">
                                <span> Manual (Operator)</span>
                            </button> -->
                        </div>
                    </div>
                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                            <div class="divider-container">
                                <div class="line"></div>
                                <span class="text">CĂUTARE DOCUMENTE - PUNCTUAL</span>
                                <div class="line"></div>
                            </div>

                            <div class="row mt-2 mb-3">
                                <div class="col-md-6 d-flex justify-content-center">
                                    <button (click)="onFiltreChange($event, 'simple')" class="btn-filter"
                                        [ngClass]="selectedFiltre === 'simple' ? 'active-btn' : 'default-btn'">
                                        Căutare simplă
                                    </button>
                                </div>
                                <div class="col-md-6 d-flex justify-content-center">
                                    <button (click)="onFiltreChange($event, 'avansate')" class="btn-filter"
                                        [ngClass]="selectedFiltre === 'avansate' ? 'active-btn' : 'default-btn'">
                                        Căutare avansată
                                    </button>
                                </div>
                            </div>

                            <ng-container *ngIf="selectedFiltre === 'simple'">
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Registru/Serie</mat-label>
                                            <mat-select formControlName="id_serie">
                                                <mat-option *ngFor="let option of serii" [value]="option.id">{{
                                                    option.name
                                                    }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr document</mat-label>
                                            <input matInput type="text" formControlName="reg_number" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Număr extern/PV</mat-label>
                                            <input matInput type="text" formControlName="extern_numar" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Acces(Intrare/Iesire)</mat-label>
                                            <mat-select formControlName="id_categorie">
                                                <mat-option *ngFor="let tipAcces of tipuriAcces" [value]="tipAcces.id">
                                                    {{
                                                    tipAcces.name }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="divider-container mb-2">
                                    <div class="line"></div>
                                    <span class="text">EMITENT/DESTINATAR DOCUMENT - EXTERN DGASPC PS4</span>
                                    <div class="line"></div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Emitent/Destinatar</mat-label>
                                            <mat-select formControlName="id_address_type">
                                                <mat-option *ngFor="let emitent of tipuriEntitati" [value]="emitent.id">
                                                    {{
                                                    emitent.name }}</mat-option></mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Denumire Entitate</mat-label>
                                            <input matInput type="text" formControlName="denumire_entity" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>CNP/CIF Entitate</mat-label>
                                            <input matInput type="text" formControlName="cnp_entity" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Email</mat-label>
                                            <input matInput type="text" formControlName="email" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <mat-form-field class="w-100">
                                        <mat-label>Observații/Mențiuni Document</mat-label>
                                        <textarea matInput type="text"
                                            formControlName="address_search_query_obs"></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Cuvinte cheie</mat-label>
                                            <input matInput type="text" formControlName="keywords" />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="selectedFiltre === 'avansate'">
                                <div class="divider-container mb-2">
                                    <div class="line"></div>
                                    <span class="text">CĂUTARE DOCUMENTE - INSTITUȚIE/SERVICIU/OPERATOR</span>
                                    <div class="line"></div>
                                </div>
                                <ng-container *ngIf="showDirectieCompartiment">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Instituție/Direcție</mat-label>
                                                <input matInput [formControl]="directiiControl"
                                                    [matAutocomplete]="autoDirectii" (blur)="onDirectiiBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoDirectii="matAutocomplete"
                                                    [displayWith]="displayDirectii"
                                                    (optionSelected)="onDirectiiChange($event.option.value)">
                                                    <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                                        Nu au fost găsite rezultate
                                                    </mat-option>
                                                    <mat-option *ngFor="let directie of filteredDirectii"
                                                        [value]="directie">
                                                        {{ directie.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Compartiment/Departament</mat-label>
                                                <input matInput [formControl]="compartimenteControl"
                                                    [matAutocomplete]="autoCompartimente"
                                                    (blur)="onCompartimenteBlur()" />
                                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                                <mat-autocomplete #autoCompartimente="matAutocomplete"
                                                    [displayWith]="displayCompartimente"
                                                    (optionSelected)="onCompartimenteSelected($event.option.value)">
                                                    <mat-option *ngIf="showCompartimenteMessage" disabled>
                                                        <span
                                                            *ngIf="!compartimenteControl.value || compartimenteControl.value.length < 2">
                                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                                        </span>
                                                        <span
                                                            *ngIf="isCompartimenteLoading && compartimenteControl.value && compartimenteControl.value.length >= 2">Căutare...</span>
                                                        <span
                                                            *ngIf="!isCompartimenteLoading && compartimenteLoadComplete && compartimente.length === 0 && compartimenteControl.value && compartimenteControl.value.length >= 2">
                                                            Nu au fost găsite rezultate
                                                        </span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let compartiment of compartimente"
                                                        [value]="compartiment">
                                                        {{ compartiment.name }}
                                                    </mat-option>
                                                </mat-autocomplete>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>
                                <div class="row">
                                    <div class="col-md-12">
                                        <mat-form-field class="w-100">
                                            <mat-label>Operator</mat-label>
                                            <mat-select formControlName="id_user">
                                                <!-- <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="operatoriControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field> -->

                                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let operator of filteredOperatori"
                                                    [value]="operator.id">
                                                    {{ operator.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Document</mat-label>
                                            <mat-select formControlName="id_tip_document"
                                                (openedChange)="onTipDocumenteClosed()">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="tipDocumenteControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>

                                                <mat-option [value]="-1">Toate</mat-option>

                                                <mat-option *ngFor="let doc of filteredTipDocumente" [value]="doc.id">
                                                    {{ doc.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Tip Finalizare</mat-label>
                                            <mat-select formControlName="finalizare_type">
                                                <mat-option *ngFor="let tipFinalizare of tipuriFinalizare"
                                                    [value]="tipFinalizare.id"> {{
                                                    tipFinalizare.name }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Cale Intrare/Ieșire</mat-label>
                                            <mat-select formControlName="source">
                                                <mat-option *ngFor="let caleIntrareIesire of surse"
                                                    [value]="caleIntrareIesire.id"> {{
                                                    caleIntrareIesire.name }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>ID document</mat-label>
                                            <input matInput type="number" formControlName="id_document" />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <mat-form-field class="w-100">
                                            <mat-label>Proveniență Document</mat-label>
                                            <mat-select formControlName="source_object">
                                                <mat-option *ngFor="let provenientaDocument of provenientaDocumente"
                                                    [value]="provenientaDocument.value"> {{
                                                    provenientaDocument.key }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </ng-container>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex p-2">
                        <div class="col-md-6 d-flex justify-content-start align-items-center">
                            <button
                                *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.filtre-avansate')"
                                class="action-button advanced-filters me-1" (click)="toggleCard()"
                                [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                                <div class="advanced-filters--chip" [ngClass]="{ 'hide-chip': !activeFilters }">
                                    <span *ngIf="activeFilters">{{ activeFilters }}</span>
                                </div>
                            </button>
                            <button class="action-button d-flex align-items-center" (click)="rerenderDT(true)">
                                <i class="fa-solid fa-search me-2"></i>
                                <span>Caută</span>
                            </button>
                        </div>
                        <div class="col-md-6 d-flex justify-content-end align-items-center flex-wrap">
                            <!-- <mat-chip-set *ngIf="notificationParameter.name" aria-label="Notification selection"
                                class="m-1">
                                <mat-chip>
                                    <div class="d-flex justify-content-center align-items-center gap-1">
                                        <span class="chip-title">
                                            {{notificationParameter.name}}
                                        </span>
                                        <mat-icon (click)="removeChip()" aria-label="Remove"
                                            style="cursor: pointer;">cancel</mat-icon>
                                    </div>
                                </mat-chip>
                            </mat-chip-set> -->
                            <mat-form-field class="active-switch-control hide-hint-area mb-1">
                                <mat-label>Serii</mat-label>
                                <mat-select [(ngModel)]="selectedRegistreActiveSwitch">
                                    <mat-option *ngFor="let option of registreActiveSwitch" [value]="option.id">
                                        {{ option.name }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <h3>Filtrare după</h3>
                                            <select [(ngModel)]="dateFilterOption" (change)="onDateFilterChange()">
                                                <option *ngFor="let option of dateFilteringOptions" [value]="option.id">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'today'
                                                " (click)="setToday()">
                                                <span>ZIUA CURENTĂ</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_1_days'
                                                " (click)="setLastXDays(1)">
                                                <span>ZIUA ANTERIOARĂ</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>ULTIMELE 7 ZILE</span>
                                            </button>
                                            <!-- <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>ULTIMELE 30 ZILE</span>
                                            </button> -->
                                            <!-- <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>ANUL CURENT</span>
                                            </button> -->
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'all_years'
                                                " (click)="setAllYears()">
                                                <span>TOATĂ PERIOADA</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"
                                                    (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PANA LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today" (selectedChange)="rerenderDT()"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                    <br>
                                    <mat-divider></mat-divider>
                                    <div class="row mt-2">
                                        <div class="col">
                                            <h3 class="m-0">Selecție rapidă (Registre)</h3>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex flex-wrap gap-2">
                                            <button *ngFor="let year of calendarYears" type="button"
                                                class="action-button m-0" [class.selected]="
                                                selectedFilteringButton === year.toString()
                                                " (click)="setSpecificYear(year)">
                                                <span>{{ year }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="row request-filter-container">
                        <div class="col-md-6 request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                (change)="onStatusChange($event)" [value]="selectedStatusID">
                                <mat-button-toggle *ngFor="let status of statusuri" [value]="status.id">
                                    {{ status.name }}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="col-md-6 request-filter">
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="w-100"
                                (change)="onCategoryChange($event)" [value]="selectedCategory">
                                <mat-button-toggle *ngFor="let option of categoryToggleOptions" [value]="option.id">
                                    {{ option.value}}
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                            <div class="d-flex justify-content-end">
                                <mat-form-field class="request-filter-subsections hide-hint-area"
                                    *ngIf="selectedCategory === 1">
                                    <mat-label>Documentele mele</mat-label>
                                    <mat-select [(ngModel)]="selectedDocumentSubsection"
                                        (selectionChange)="rerenderDT(true)">
                                        <mat-option *ngFor="let option of myDocumentSubsectionOptions"
                                            [value]="option.id">
                                            {{
                                            option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="request-filter-subsections hide-hint-area"
                                    *ngIf="selectedCategory === 2">
                                    <mat-label>Departamentul meu</mat-label>
                                    <mat-select [(ngModel)]="selectedDepartmentSubsection"
                                        (selectionChange)="rerenderDT(true)">
                                        <mat-option *ngFor="let option of myDepartmentSubsectionOptions"
                                            [value]="option.id"> {{
                                            option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="request-filter-subsections hide-hint-area"
                                    *ngIf="selectedCategory === 5">
                                    <mat-label>De finalizat</mat-label>
                                    <mat-select [(ngModel)]="selectedFinishSubsection"
                                        (selectionChange)="rerenderDT(true)">
                                        <mat-option *ngFor="let option of toFinishSubsectionOptions"
                                            [value]="option.id"> {{
                                            option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="request-filter-subsections hide-hint-area"
                                    *ngIf="selectedCategory === 4">
                                    <mat-select [(ngModel)]="selectedMessageSubsection"
                                        (selectionChange)="rerenderDT(true)">
                                        <mat-option *ngFor="let option of myMessagesSubsectionOptions"
                                            [value]="option.id"> {{
                                            option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field class="request-filter-subsections hide-hint-area"
                                    *ngIf="selectedCategory === 9">
                                    <mat-select [(ngModel)]="selectedToSignSubsection"
                                        (selectionChange)="rerenderDT(true)">
                                        <mat-option *ngFor="let option of myCheckSignDocsSubsectionOptions"
                                            [value]="option.id"> {{
                                            option.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <table id="datatable" class="row-border hover custom-dt w-100" datatable [dtOptions]="dtOptions"
                            [dtTrigger]="dtTrigger"></table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading || isGeneralDataLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">
                                {{ helper.dialogConfig.generalMessages.pleaseWait }}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Scroll to Top Button -->
<button class="scroll-to-top-btn" *ngIf="showScrollToTop" (click)="scrollToTop()" title="Înapoi sus" [@fadeInOut]>
    <i class="fa-solid fa-arrow-up"></i>
</button>